import {useCallback} from 'react';
import {useTemplateHelpers} from '~/GalleryPB/hooks/useTemplateHelpers';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useIsMediumAndUp} from '~library/hooks/useMatchQuery';
import {PlusIcon} from '~library/svg/PlusIcon';

import './QuickViewButton.sass';

type QuickViewButtonProps = {
  templateId: string;
  onClickQuickView: (templateId: string) => void;
  usedAs: string;
};

export const QuickViewButton = ({onClickQuickView, templateId, usedAs}: QuickViewButtonProps) => {
  const isMediumAndUp = useIsMediumAndUp();
  const isCard = usedAs === 'card';
  const {checkIfQuickViewEnabled} = useTemplateHelpers();
  const isQuickViewEnabled = checkIfQuickViewEnabled(templateId);

  const onClickHandler = useCallback(
    () => onClickQuickView(templateId),
    [templateId, onClickQuickView]
  );

  return (
    isQuickViewEnabled &&
    !isCard &&
    isMediumAndUp && (
      <Button
        variant="transparent"
        onClick={onClickHandler}
        data-qa-id="pdp-quick-view-btn"
        data-impression-tracking="true"
        className="quick-view__button"
      >
        <PlusIcon ratio={0.5} />
        <Typography variant="label2">Quick View</Typography>
      </Button>
    )
  );
};
